import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DateField } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const PaymentForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  heading = '',
  handleCloseModal,
  setFieldValue
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>

      <TextField
        error={Boolean(touched.amount && errors.amount)}
        fullWidth
        helperText={touched.amount && errors.amount}
        label="Amount"
        margin="normal"
        name="amount"
        onBlur={handleBlur}
        onChange={handleChange}
        type="number"
        value={values.amount}
        variant="outlined"
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateField
          error={Boolean(
            touched.payment_for_this_month && errors.payment_for_this_month
          )}
          fullWidth
          helperText={
            touched.payment_for_this_month && errors.payment_for_this_month
          }
          InputLabelProps={{
            shrink: true
          }}
          format="MM-YYYY"
          label="Payment for the month"
          margin="normal"
          name="payment_for_this_month"
          onBlur={handleBlur}
          onChange={(value) => {
            setFieldValue('payment_for_this_month', value);
          }}
          value={dayjs(
            dayjs(values.payment_for_this_month).format('YYYY-MM-DD')
          )}
          variant="outlined"
        />
      </LocalizationProvider>

      <TextField
        error={Boolean(
          touched.payment_received_on && errors.payment_received_on
        )}
        fullWidth
        helperText={touched.payment_received_on && errors.payment_received_on}
        label="Payment received on"
        margin="normal"
        name="payment_received_on"
        InputLabelProps={{
          shrink: true
        }}
        onBlur={handleBlur}
        onChange={handleChange}
        type="date"
        value={values.payment_received_on}
        variant="outlined"
      />

      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="mode_of_payment-select"
      >
        <InputLabel id="mode_of_payment-label">Mode of payment</InputLabel>
        <Select
          labelId="mode_of_payment-label"
          id="mode_of_payment"
          value={values.mode_of_payment}
          onChange={handleChange}
          label="mode_of_payment"
          name="mode_of_payment"
        >
          <MenuItem name="mode_of_payment" value={0}>
            Cash
          </MenuItem>
          <MenuItem name="mode_of_payment" value={1}>
            Cheque
          </MenuItem>
          <MenuItem name="mode_of_payment" value={2}>
            Card paymet
          </MenuItem>
          <MenuItem name="mode_of_payment" value={3}>
            Online payment
          </MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ py: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {heading}
        </Button>
      </Box>
    </form>
  );
};

export default PaymentForm;
